import { render } from "./EditChecklist.vue?vue&type=template&id=9bfbe7ca&ts=true"
import script from "./EditChecklist.vue?vue&type=script&lang=ts"
export * from "./EditChecklist.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__